import { render, staticRenderFns } from "./messageGroupEdit.vue?vue&type=template&id=bb5f458a"
import script from "./messageGroupEdit.vue?vue&type=script&lang=js"
export * from "./messageGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports